/**
 * Grace windows for submission edits and treatment row deletes.
 *
 * SHER-782: these were one shared 1-hour window. They are now separate, because
 * they guard different things. An edit is an amendment — the audit trail records
 * it either way, and the window only decides whether the clinician is asked to
 * type a reason. A delete removes a prescribed row, so it keeps the tighter
 * window it was given in SHER-383.
 *
 * The edit window must stay below the 48h password re-authentication threshold in
 * sherwood-api updateSubmission: past that the API demands a password, and a
 * window wider than it would ask for a password while waiving the reason.
 *
 * Both values must stay aligned with sherwood-api updateSubmission grace logic —
 * the API enforces the windows independently, and these constants only decide
 * whether the client prompts before trying.
 */

export const SUBMISSION_GRACE_PERIOD_MS = 60 * 60 * 1000;

export const SUBMISSION_EDIT_GRACE_PERIOD_MS = 8 * 60 * 60 * 1000;

export function isWithinSubmissionGracePeriod(
    createdAt: string | Date | null | undefined,
    now: number = Date.now(),
    windowMs: number = SUBMISSION_GRACE_PERIOD_MS,
): boolean {
    if (!createdAt) {
        return false;
    }
    const age = now - new Date(createdAt).getTime();
    return age >= 0 && age < windowMs;
}

export function isWithinSubmissionEditGracePeriod(
    createdAt: string | Date | null | undefined,
    now: number = Date.now(),
): boolean {
    return isWithinSubmissionGracePeriod(createdAt, now, SUBMISSION_EDIT_GRACE_PERIOD_MS);
}
